import type { QueryClient } from '@tanstack/react-query';

import { api, trpcClient } from './client';

export function TRPCReactProvider({
	children,
	client,
}: {
	children: React.ReactNode;
	client: QueryClient;
}) {
	return (
		<api.Provider client={trpcClient} queryClient={client}>
			{children}
		</api.Provider>
	);
}
